import { API } from "config";
import type { ChatThread } from "types/ChatThread";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

type GetThreadsResponseBody = ChatThread[];

/**
 * Returns the user's chat threads (without messages).
 */
export async function getThreads(
  getAccessToken: () => Promise<string>
): Promise<GetThreadsResponseBody> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/threads`;
  const headers = { Authorization: `Bearer ${accessToken}` };
  const options = { method: "GET", headers };

  const response = await request(url, options);
  return (await response.json()) as GetThreadsResponseBody;
}
